import {
  THierarchyItemCreateForm,
  THierarchyItemEditForm,
  THierarchyTreeSubitem,
} from 'core/model/interfaces/navigation/hierarchy.interface';
import { hierarchyData } from './hierarchy.data';
import { IPostHierarchyTreeItemsOrder, IPostHierarchyTreeSubitemsOrder } from './hierarchy.dto';
import {
  mapHierarchyItems,
  mapHierarchySubitems,
  toPostHierarchyItemBody,
  toPostHierarchyTreeSubitemBody,
  toPutHierarchyItemBody,
  toPutHierarchySubitemBody,
} from './hierarchy.mapper';

export const hierarchyService = {
  getHierarchyItems: async (treeId: string) => {
    const hierarchyItemsResponse = await hierarchyData.getHierarchyItems(treeId);
    const mappedHierarchy = mapHierarchyItems(treeId, hierarchyItemsResponse);
    return mappedHierarchy;
  },

  getHierarchySubitems: async (treeId: string, itemId: string) => {
    const hierarchyItemsResponse = await hierarchyData.getHierarchySubitems(treeId, itemId);
    const mappedHierarchy = mapHierarchySubitems(treeId, itemId, hierarchyItemsResponse);
    return mappedHierarchy;
  },

  createHierachyItem: async (body: THierarchyItemCreateForm) => {
    const mappedBody = toPostHierarchyItemBody(body);
    return hierarchyData.createHierachyItem(mappedBody, body.treeId);
  },

  editHierachyItem: async (body: THierarchyItemEditForm): Promise<void> => {
    const mappedBody = toPutHierarchyItemBody(body);
    return hierarchyData.editHierachyItem(mappedBody, body.treeId, body.id);
  },

  createHierachySubitem: (body: Omit<THierarchyTreeSubitem, 'id'>) => {
    const mappedBody = toPostHierarchyTreeSubitemBody(body);
    return hierarchyData.createHierachySubitem(mappedBody);
  },

  editHierachySubitem: (body: THierarchyTreeSubitem) => {
    const mappedBody = toPutHierarchySubitemBody(body);
    return hierarchyData.editHierachySubitem(mappedBody);
  },

  deleteHierarchyItem: (itemId: string, treeId: string) => hierarchyData.deleteHierarchyItem(itemId, treeId),

  deleteHierarchySubitem: (id: string, itemId: string, treeId: string) =>
    hierarchyData.deleteHierarchySubitem(id, itemId, treeId),

  publishHierachyTrees: (id: string) => hierarchyData.publishHierachyTrees(id),

  updateHierarchyItemsOrder: (body: IPostHierarchyTreeItemsOrder) => hierarchyData.updateHierarchyItemsOrder(body),

  updateHierarchySubitemsOrder: (body: IPostHierarchyTreeSubitemsOrder) =>
    hierarchyData.updateHierarchySubtemsOrder(body),
};
